import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetRolePermissionsList = () => {
  const [loading, setLoading] = useState(true);
  const [rolePermissionsList, setRolePermissionsList] = useState([]);
  const [pageRef, setPageRef] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const getRolePermissionsList = ({ Guid, Page, Count, onSuccess }) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/Role/Permission/List', {
        params: { Guid, Page, Count },
      })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);
          setRolePermissionsList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.permissionGuid,
              display: element.display,
            }));
            onSuccess?.();
            return { ...prev, [Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return {
    getRolePermissionsList,
    loading,
    rolePermissionsList,
    pageRef,
  };
};

export { useGetRolePermissionsList };
